import { BrowserRouter, Route, Routes } from "react-router-dom";
import { AdminShell } from "@/components/layout/AdminShell";
import { ProtectedRoute } from "@/components/layout/ProtectedRoute";
import { ApiProvider } from "@/lib/api";
import { AuthProvider } from "@/lib/auth";
import { QueryProvider } from "@/lib/query/QueryProvider";
import { ThemeProvider } from "@/lib/theme/ThemeProvider";
import { AuditScreen } from "@/screens/AuditScreen";
import { CafeDetailScreen } from "@/screens/CafeDetailScreen";
import { CafesScreen } from "@/screens/CafesScreen";
import { CitiesScreen } from "@/screens/CitiesScreen";
import { CorrectionsScreen } from "@/screens/CorrectionsScreen";
import { DashboardScreen } from "@/screens/DashboardScreen";
import { FeedbackScreen } from "@/screens/FeedbackScreen";
import { GoalsScreen } from "@/screens/GoalsScreen";
import { NotFoundScreen } from "@/screens/NotFoundScreen";
import { OpsScreen } from "@/screens/OpsScreen";
import { ProposalsScreen } from "@/screens/ProposalsScreen";
import { ReportsScreen } from "@/screens/ReportsScreen";
import { ReviewDetailScreen } from "@/screens/ReviewDetailScreen";
import { ReviewsScreen } from "@/screens/ReviewsScreen";
import { UserDetailScreen } from "@/screens/UserDetailScreen";
import { UsersScreen } from "@/screens/UsersScreen";

/**
 * Provider order is load-bearing.
 *
 * Theme outermost, so the sign-in screen is painted in the right palette
 * before there is a session. Auth above Api, because the client asks the
 * auth layer for a token on every request. Query innermost, so a sign-out
 * unmounting the tree also drops every cached response with it — a console
 * that kept one operator's queue in memory across a sign-out would be a
 * small but real leak between people.
 */
export function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <ApiProvider>
          <QueryProvider>
            <BrowserRouter>
              <ProtectedRoute>
                <Routes>
                  <Route element={<AdminShell />}>
                    <Route index element={<DashboardScreen />} />
                    <Route path="goals" element={<GoalsScreen />} />
                    <Route path="cities" element={<CitiesScreen />} />
                    <Route path="reports" element={<ReportsScreen />} />
                    <Route path="proposals" element={<ProposalsScreen />} />
                    <Route path="corrections" element={<CorrectionsScreen />} />
                    <Route path="feedback" element={<FeedbackScreen />} />
                    <Route path="cafes" element={<CafesScreen />} />
                    <Route
                      path="cafes/:cafeId"
                      element={<CafeDetailScreen />}
                    />
                    <Route path="reviews" element={<ReviewsScreen />} />
                    <Route
                      path="reviews/:reviewId"
                      element={<ReviewDetailScreen />}
                    />
                    <Route path="users" element={<UsersScreen />} />
                    <Route
                      path="users/:userId"
                      element={<UserDetailScreen />}
                    />
                    <Route path="ops" element={<OpsScreen />} />
                    <Route path="audit" element={<AuditScreen />} />
                    <Route path="*" element={<NotFoundScreen />} />
                  </Route>
                </Routes>
              </ProtectedRoute>
            </BrowserRouter>
          </QueryProvider>
        </ApiProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}
